/** Cognito page-id aliases (keep in sync with App.tsx PAGE_PERMISSION_ALIASES where relevant). */
const PAGE_PERMISSION_ALIASES: Record<string, string[]> = {
  'profit-agent': ['profit-agent'],
  'customs-agent': ['customs-agent'],
  'profitability-report': ['profitability-report'],
  // Keep in sync with App.tsx — new Profit is independent of legacy / Control Centre.
  'ops-profit': ['ops-profit'],
  // Keep in sync with App.tsx — System Health used to be part of Control Centre.
  'system-health': ['system-health', 'fleet-data-hub'],
  assets: ['assets', 'configuration'],
  configuration: ['configuration', 'assets'],
};

type SessionAccess = {
  isAdmin: boolean;
  permissions: string[];
};

function readSessionAccess(): SessionAccess {
  try {
    const idToken = localStorage.getItem('zecure_cognito_id_token');
    if (!idToken) return { isAdmin: false, permissions: [] };
    const payload = JSON.parse(atob(idToken.split('.')[1]));
    const permissions = payload['custom:permissions']
      ? String(payload['custom:permissions'])
          .split(',')
          .map((p: string) => p.trim())
          .filter(Boolean)
      : [];
    return {
      isAdmin: payload['custom:isAdmin'] === 'true',
      permissions,
    };
  } catch {
    return { isAdmin: false, permissions: [] };
  }
}

/** Whether the signed-in user may open a sidebar page (admin = all). */
export function hasPageAccess(pageId: string): boolean {
  const { isAdmin, permissions } = readSessionAccess();
  if (isAdmin) return true;
  const accepted = PAGE_PERMISSION_ALIASES[pageId] || [pageId];
  return accepted.some((id) => permissions.includes(id));
}

/** Whether the signed-in user is an admin (from the verified Cognito ID token). */
export function isSessionAdmin(): boolean {
  return readSessionAccess().isAdmin;
}
